// extracted by mini-css-extract-plugin
export default {"container":"root_container__N2UN2"};